import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSettingsCookie = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19 19H22M19 19C19 20.6568 17.6569 22 16 22C14.3431 22 13 20.6568 13 19C13 17.3431 14.3431 16 16 16C17.6569 16 19 17.3431 19 19ZM2 12H5M5 12C5 13.6568 6.34315 15 8 15C9.65685 15 11 13.6568 11 12C11 10.3431 9.65685 9 8 9C6.34315 9 5 10.3431 5 12ZM19 5H22M19 5C19 6.65685 17.6569 8 16 8C14.3431 8 13 6.65685 13 5C13 3.34314 14.3431 2 16 2C17.6569 2 19 3.34314 19 5ZM2 19H10M14 12H22M2 5H10",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round"
	})
});
export default SvgSettingsCookie;
